<template>
  <div>
    <b-card :title="isEdit ? 'تعديل مركز' : 'اضافة مركز'">
      <validation-observer
        ref="form"
        #default="{ handleSubmit }"
      >
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="name_ar"
                rules="required"
              >
                <b-form-group
                  label="الاسم العربي"
                  label-for="name_ar"
                >
                  <b-form-input
                    id="name_ar"
                    v-model="form.name_ar"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="name_en"
                rules="required"
              >
                <b-form-group
                  label="الاسم الانجليزي"
                  label-for="name_en"
                >
                  <b-form-input
                    id="name_en"
                    v-model="form.name_en"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="governorate_id"
                rules="required"
              >
                <b-form-group
                  label="المحافظة"
                  label-for="governorate_id"
                >
                  <v-select
                    id="governorate_id"
                    v-model="form.governorate_id"
                    :options="governoratesDropdown"
                    :reduce="val => val.id"
                    :get-option-label="option => option.name_ar"
                    :placeholder="المحافظة"
                    :state="errors.length > 0 ? false : null"
                    @input="fetchCenters"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <b-form-group label="الحالة">
                <b-form-checkbox
                  v-model="form.is_active"
                  switch
                >
                  {{ form.is_active ? $t('common.active') : $t('common.inactive') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                حفظ
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="$router.go(-1)"
              >
                الغاء
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      form: {
        name_ar: '',
        name_en: '',
        governorate_id: null,
        is_active: true,
      },
      required,
    }
  },
  computed: {
    ...mapGetters({
      governoratesDropdown: 'governorates/dropdown',
    }),
    isEdit() {
      return !!this.$route.params.id
    },
  },
  mounted() {
    this.fetchGovernoratesDropdown()
    if (this.isEdit) {
      this.fetchCenter()
    }
  },
  methods: {
    fetchGovernoratesDropdown() {
      this.$store.dispatch('governorates/dropdown')
    },
    fetchCenter() {
      this.$store.dispatch('centers/get', this.$route.params.id)
        .then(response => {
          this.form = { ...response.data }
        })
        .catch(error => {
          this.$toast.error('خطأ في المركز')
        })
    },
    onSubmit() {
      const action = this.isEdit ? 'update' : 'create'
      const payload = this.isEdit ? { id: this.$route.params.id, data: this.form } : this.form

      this.$store.dispatch(`centers/${action}`, payload)
        .then(() => {
          this.$swal.fire({
            title: 'تم التعديل بنجاح',
            icon: 'success',
            timer: 1500,
          })
          this.$router.push({ name: 'settings-centers' })
        })
        .catch(error => {
          this.$swal.fire({
            title: 'خطأ',
            icon: 'error',
            timer: 1500,
          })
          this.$toast.error('خطأ في المركز')
        })
    },
  },
}
</script>

  <style lang="scss" scoped>
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
